// assets/animation-text.js

/**
 * animateText animates text in a given element, displaying it letter-by-letter.
 * It now handles multiple lines by splitting the text at newline characters.
 *
 * @param {string} selector - The CSS selector for the target element.
 * @param {string} text - The text to animate, with newline characters (\n) to denote line breaks.
 * @param {object} options - Optional settings:
 *    - speed: number (typing speed in milliseconds; default: 50)
 */
function animateText(selector, text, options) {
  var container = document.querySelector(selector);
  if (!container) return;
  
  // Split text into lines by newline character
  var lines = text.split('\n');
  container.innerHTML = "";
  
  var speed = (options && options.speed) ? options.speed : 50;
  var currentLine = 0;

  // Animate one line at a time
  function animateLine(lineText, callback) {
    var lineSpan = document.createElement('span');
    // Display each line as a block so that new lines appear beneath the previous
    lineSpan.style.display = 'block';
    container.appendChild(lineSpan);

    var charIndex = 0;
    function typeChar() {
      if (charIndex < lineText.length) {
        lineSpan.textContent += lineText.charAt(charIndex);
        charIndex++;
        setTimeout(typeChar, speed);
      } else if (typeof callback === 'function') {
        callback();
      }
    }
    typeChar();
  }

  // Animate each line in sequence
  function animateNextLine() {
    if (currentLine < lines.length) {
      animateLine(lines[currentLine], function() {
        currentLine++;
        animateNextLine();
      });
    }
  }
  
  animateNextLine();
}

// Expose the function globally so it can be called from any section.
window.animateText = animateText;